import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { NgxHttpClientExtraOptions } from 'ngx-httpclient';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DeportesListarService {
  /**
   * @description Constructor
   * @params http
   */
  constructor(
    private http: HttpClient,
  ) {
    this.http = http;
  }
  /**
   * @description recuperar lista deportes
   */
  getSportsList(): Observable<object> {
    const httpOpt: NgxHttpClientExtraOptions = {
      headers: new HttpHeaders()
        .append('Content-Type', 'application/x-www-form-urlencoded')
    };

    return this.http.get(
      environment.endpoints.urlBase +
      environment.endpoints.deportesListar.name,
      httpOpt
    ).pipe(
      map((response: any[]) => {
        return response.map((item: any) => ({
          Id_Deporte: item.idDeporte,
          Des_Deporte: item.desDeporte
        }));
      })
    );
  }
}

